import React from 'react';
import { TTextTranslationNamespaces } from 'types';
import Text from 'components/Text/Text';
import { TooltipForTextNew } from 'components/Tooltips/TooltipForTextNew';
import classNames from 'classnames';

interface IProps {
	translationKey: Nullable<string>;
	translationNameSpace: TTextTranslationNamespaces;
	isActive: boolean;
	testId: string;
	onClick: () => void;
}

export const FormSideTab: React.FC<IProps> = ({ translationKey, translationNameSpace, isActive, testId, onClick }) => {
	const containerClasses = classNames('px-4 py-2 border border-solid rounded text-base leading-5 select-none', {
		'border-blue-05-new bg-blue-05-new font-bold text-white-00-new cursor-default': isActive,
		'border-purple-02-new bg-white-00-new text-grey-10-new cursor-pointer hover:text-purple-07-new': !isActive,
	});

	return (
		<div className={containerClasses} data-test={testId} onClick={isActive ? undefined : onClick}>
			<TooltipForTextNew>
				<Text translationNameSpace={translationNameSpace} translationKey={translationKey} asFragment={true} />
			</TooltipForTextNew>
		</div>
	);
};
